<template>
  <td>
    <div class="slack">
      <v-checkbox
        color="primary"
        class="mt-0"
        hide-details
        style="display: inline-block;"
        v-model="slackForm.enabled"
        label="Slack"
        @change="hide = (slackForm.enabled ? !slackForm.enabled : hide)"
      />
      <v-icon style="cursor-pointer" @click="hide = !hide">{{ hide ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
    </div>
    <div v-show="!hide" class="google-security">
      <v-form
        ref="slackForm"
        v-model="slackForm.valid"
        lazy-validation
      >
        <v-text-field
          label="Bot User OAuth Token"
          v-model="slackForm.data.access_token"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setSlack"
        >
        </v-text-field>
      </v-form>
    </div>
  </td>
</template>
<script>
export default {
  name: 'SlackConfigureForm',
  props: ['slack'],
  created () {
    this.slackForm = this.slack
  },
  data () {
    return {
      slackForm: null,
      hide: true,
      rules: {
        required: v => !!v || 'Required.'
      }
    }
  },
  methods: {
    setSlack () {
      this.$emit('setData', 'slack', this.slackForm)
    }
  }
}
</script>
<style lang="scss" scoped>
  .slack {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
</style>
